const getScreenInfo = () => {
  if (typeof window === 'undefined') {
    return { minDimension: 0 };
  }

  const width = window.innerWidth ?? 0;
  const height = window.innerHeight ?? 0;
  const minDimension = Math.min(width, height);

  return { minDimension };
};

const isSmallViewport = () => {
  const { minDimension } = getScreenInfo();

  if (!minDimension) {
    return false;
  }

  // Breakpoint for small viewports, change threshold here. Currently,
  // this does not block iPad minis (768px width). Should we?
  return minDimension < 768;
};

export const isPhoneDevice = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return isSmallViewport();
};
